import { BlastMetadataDto, SiteDto } from "../../../types/blastDtos";
import { OrgDto, UserDto } from "../../../types/dto";
import { getBlast, isMockMode, simulateDelay } from "../../api";

export interface GetBlastMetadataResponse {
	blast: BlastMetadataDto;
	site: SiteDto;
	org: OrgDto;
}

export const getBlastMetadata = (
	{
		blastId,
		shareLinkId,
	}: {
		blastId: string;
		shareLinkId?: string;
	},
	isAnon = false as boolean
): Promise<GetBlastMetadataResponse> => {
	if (isMockMode()) {
		const testData = {
			blast: {
				id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
				name: "string",
				siteId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
				createdDateUtc: "2024-10-16T06:15:41.262Z",
				createdBy: {
					id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
					email: "string",
					firstName: "string",
					lastName: "string",
				},
				metadataLastUpdatedUtc: "2024-10-16T06:15:41.262Z",
				metadataLastUpdatedBy: {
					id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
					email: "string",
					firstName: "string",
					lastName: "string",
				},
				isPublished: true,
				isDeleted: true,
				dataLastUpdatedUtc: "2024-10-16T06:15:41.262Z",
				dataLastUpdatedBy: {
					id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
					email: "string",
					firstName: "string",
					lastName: "string",
				},
				updateCount: 0,
				stateHash: {},
				sizeInBytes: 0,
				userCanAdmin: true,
				userCanWrite: true,
			},
			site: {
				id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
				name: "string",
				subscriptionId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
				subscriptionSubscriberOrgId:
					"3fa85f64-5717-4562-b3fc-2c963f66afa6",
			},
			org: {
				id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
				name: "string",
				isEnabledShareWithAnon: true,
				isEnabledShareOutsideOrg: true,
			},
		};
		return simulateDelay(50, () => testData);
	}

	return getBlast(
		`blasts/getMetadata${
			isAnon ? "-anon" : ""
		}?blastId=${blastId}&shareLinkId=${shareLinkId || ""}`
	);
};
